import {UserInfo} from '../../../constants';

export function setAffidUuid(uuid: string) {
  if (!uuid) {
    return;
  }
  sessionStorage.setItem(UserInfo.affidUuid, uuid);
}
